import { Stack, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { PageHeaderContainer } from "share-components/templates/page/page-header-container";

import { WorkOrdersPermission } from "commons/enum/permission";
import { Dayjs } from "dayjs";
import { DateRange } from "share-components/atomics/date-range";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { XSearchTextField } from "share-components/mui-wrap/text-field/x-search-text-field";
import { AddWorkOrder } from "../add-work-order/add-work-order";
import { WorkOrderTable } from "./work-order-table";

export const WorkOrderList = observer(() => {
  const {
    workOrderManagement: {
      openNew,
      getWorkOrders,
      pagination,
      queryParams: {
        dateRangeFilter: { fromAsDayJs, toAsDayJs, setProp: setDateRangeProps },
        name,
        dealingName,
        wONumber,
        setProp: setQueryParamProp,
      },
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getWorkOrders();
  }, [getWorkOrders, pagination]);

  const fromDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("from", value ? value.toString() : null);
    },
    [setDateRangeProps]
  );

  const toDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("to", value ? value.toString() : null);
    },
    [setDateRangeProps]
  );

  return (
    <>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header></Header>
      </PageHeaderContainer>
      <PageFilterContainer
        direction={"row"}
        spacing={1}
        alignItems={"center"}
        flexWrap={"wrap"}
        rowGap={"10px"}
      >
        <DateRange
          label={"Ngày LSX"}
          fromDate={fromAsDayJs}
          toDate={toAsDayJs}
          onFromDateChanged={fromDateChangedHandler}
          onToDateChanged={toDateChangedHandler}
        ></DateRange>
        <XSearchTextField
          label="Tên giao dịch"
          value={dealingName}
          onChange={(e) =>
            setQueryParamProp("dealingName", e.currentTarget.value)
          }
        ></XSearchTextField>

        <XSearchTextField
          label="Số phiếu"
          value={wONumber}
          onChange={(e) => setQueryParamProp("wONumber", e.currentTarget.value)}
        ></XSearchTextField>

        <XSearchTextField
          label="Tên hàng"
          value={name}
          onChange={(e) => setQueryParamProp("name", e.currentTarget.value)}
        ></XSearchTextField>
        <SearchButton asyncAction={onSearch}></SearchButton>
      </PageFilterContainer>
      <PageContentContainer>
        <WorkOrderTable></WorkOrderTable>
      </PageContentContainer>

      <>{openNew && <AddWorkOrder></AddWorkOrder>}</>
    </>
  );
});

const Header = observer(() => {
  const {
    workOrderManagement: { setProp },
  } = useStores();
  return (
    <>
      <Stack>
        <Typography variant="subtitle2">Quản lý lệnh sản xuất</Typography>
      </Stack>
      <Stack>
        <AddButton
          accessPermission={[WorkOrdersPermission.Create]}
          onClick={() => {
            setProp("openNew", true);
          }}
        >
          Thêm mới
        </AddButton>
      </Stack>
    </>
  );
});
